import {
  tInsertQuickReplyOptions,
  tQuickReplyTriggerOptions,
} from './QuickAction.types.ts';

/**
 * BUG-1157: posición de la `/` que abrió el panel, o -1 si el panel se abrió
 * con el botón o esa `/` ya no está antes del cursor. No se usa la primera `/`
 * del texto: un link (`https://…`) o una fecha (`30/10`) también la tienen y
 * la búsqueda dejaba la lista vacía.
 */
export function getQuickReplyTriggerIndex(
  options: tQuickReplyTriggerOptions,
): number {
  const { text, cursor, triggerIndex } = options;
  if (triggerIndex === null) return -1;
  if (triggerIndex >= cursor || text[triggerIndex] !== '/') return -1;
  return triggerIndex;
}

/** Lo escrito entre la `/` que abrió el panel y el cursor. */
export function getQuickReplySearch(options: tQuickReplyTriggerOptions): string {
  const index = getQuickReplyTriggerIndex(options);
  if (index === -1) return '';
  return options.text.slice(index + 1, options.cursor).trim();
}

/**
 * Quita la `/` que abrió el panel y lo buscado, y pega la respuesta al final.
 * El resto del texto (links incluidos) queda igual.
 */
export function insertQuickReplyText(options: tInsertQuickReplyOptions): string {
  const { text, cursor, replyText } = options;
  const index = getQuickReplyTriggerIndex(options);
  const base =
    index === -1
      ? text.trim()
      : (text.slice(0, index) + text.slice(cursor)).trim();
  return replyText ? `${base} ${replyText}` : base;
}
